<div class="wrap-sub-plan-associations">
  <!-- search user / vehicle -->
  <div class="sub-plan-associations-row" (keydown.enter)="$event.preventDefault()">
    <!-- search item (user / vehicle) -->
    <div class="sub-plan-associations-item-form">
      <input type="text" class="form-control" [placeholder]="itemPlaceholder" [formControl]="searchedItem" [matAutocomplete]="idItems"
        (keyup)="onChangeSearchedItem($event.target.value)">
      <mat-autocomplete #idItems="matAutocomplete" [displayWith]="displayItem">
        @for (item of items; track item) {
          <mat-option class="option-wrap" [value]="item" (click)="onClickItemOption(item)">
            <span class="option-value">{{item.displayName}}</span>
            <span class="btn-add icon-plus"></span>
          </mat-option>
        }
      </mat-autocomplete>
      <!-- <div *ngIf="searchedItem.invalid && (searchedItem.dirty || searchedItem.touched)" class="alert alert-danger">
      <div *ngIf="searchedItem.errors.required">
        {{'error.is_required' | translate}}
      </div>
    </div> -->
  </div>
  <!-- badges -->
  <div disabled class="sub-plan-associations-badges">
    <input type="text" class="form-control" [placeholder]="badgesPlaceholder" [formControl]="searchedBadge" [matAutocomplete]="idBadges"
      (keyup)="onChangeSearchedBadge($event.target.value)">
    <mat-autocomplete #idBadges="matAutocomplete" [displayWith]="displayBadge">
      @for (badge of badges; track badge) {
        <mat-option class="option-wrap" [value]="badge" (click)="onClickBadgeOption(badge)">
          <span class="option-value">{{badge.displayName}}</span>
          <span class="btn-add icon-plus"></span>
        </mat-option>
      }
    </mat-autocomplete>
    @if (errorAssignBadge) {
      <div class="alert alert-danger">
        <div>{{ errorAssignBadgeMsg | translate}}</div>
      </div>
    }
  </div>
  <!-- badges of items actually linked in db -->
  @if (currentItem && badgeTable) {
    <ul class="sub-plan-associations-linked-badges">
      <h2 class="sub-plan-associations-linked-badges-title">{{titleTableBadge | translate: {associatedBadges: $safeNavigationMigration(allActualBadges?.length)} }}</h2>
      <!-- LIST -->
      <div class="ui-table" [tableInput]="badgeTable" (eventOnClick)="onEventOnClick($event)"></div>
      <!-- PAGING -->
      <div class="ui-paging" [pagingInput]="paging"
        (eventOnClickPrevLink)="eventOnClickPrevLink($event)"
        (eventOnClickNextLink)="eventOnClickNextLink($event)">
      </div>
    </ul>
  }
</div>
</div>
